"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resolver__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "Set",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
        ],
        name: "get",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "set",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Resolver__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Resolver__factory = Resolver__factory;
Resolver__factory.bytecode = _bytecode;
Resolver__factory.abi = _abi;
//# sourceMappingURL=Resolver__factory.js.map